import { ComposeChildren } from '@frontend-libs/base-react'
import { CssBaseline } from '@mui/material'
import { type PropsWithChildren } from 'react'
import { Bounce, ToastContainer } from 'react-toastify'

import { IS_DEV_ENV } from '~sharedConfig'

import { BrowserStatusesController } from './browserStatusesController'
import { TanStackQueryDevTools } from './devtools'
import { AppRenderingErrorBoundary } from './renderError/app'
import { TanstackQueryController } from './tanstackQuery'
import { AppThemeProvider } from './theme'

export const WithProviders = ({ children }: PropsWithChildren) => (
	<>
		<ComposeChildren>
			<AppRenderingErrorBoundary />
			<AppThemeProvider />
			<TanstackQueryController />
			<BrowserStatusesController />
			{IS_DEV_ENV ? <TanStackQueryDevTools /> : null}
			<>
				<CssBaseline />
				{children}
			</>
		</ComposeChildren>
		<ToastContainer
			toastStyle={{ minWidth: 'max-content' }}
			autoClose={3000}
			limit={3}
			theme='colored'
			stacked
			hideProgressBar={false}
			position='top-center'
			transition={Bounce}
		/>
	</>
)
